import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { useAuth } from './AuthContext';
import toast from 'react-hot-toast';

const SocketContext = createContext(null);

export const useSocket = () => {
  return useContext(SocketContext);
};

export const SocketProvider = ({ children }) => {
  const [socket, setSocket] = useState(null);
  const [connected, setConnected] = useState(false);
  const { user, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated && user) {
      const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || window.location.origin;
      const newSocket = io(SOCKET_URL, {
        auth: { token: localStorage.getItem('token') },
        transports: ['websocket', 'polling'],
        upgrade: true,
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 2000,
      });

      newSocket.on('connect', () => {
        console.log('Socket connected');
        setConnected(true);
        newSocket.emit('join', user._id);
      });

      newSocket.on('disconnect', () => {
        console.log('Socket disconnected');
        setConnected(false);
      });

      // Listen for notifications
      newSocket.on('notification', (notification) => {
        toast(notification.message, {
          icon: '🔔',
          duration: 5000,
        });
      });

      // Listen for task updates
      newSocket.on('taskUpdated', (task) => {
        // Can be handled by specific components
      });

      // Listen for project updates
      newSocket.on('projectUpdated', (project) => {
        // Can be handled by specific components
      });

      setSocket(newSocket);

      return () => {
        newSocket.close();
      };
    }
  }, [isAuthenticated, user]);

  const value = {
    socket,
    connected,
  };

  return <SocketContext.Provider value={value}>{children}</SocketContext.Provider>;
};
